document.addEventListener("DOMContentLoaded", () => {
  const videoBackground = document.querySelector(".video-background");
  const video = videoBackground.querySelector("video");

  if (video) {
    video.addEventListener("loadeddata", () => {
      videoBackground.classList.add("loaded");
    });
  }
});
